<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h1 class="text-primary">
            {{ $t("common.labels.manageTitle") }} {{ titlePlural }}
          </h1>
          <div class="row" v-if="innerOptions.stats">
            <stats
              :url="`/crud/${name}/stats`"
              :entity="name"
              :statsNeedsRefresh.sync="statsNeedsRefresh"
            ></stats>
          </div>
          <div class="text-right">
            <template v-if="options && options.customTopRightActions">
              <button
                v-for="(action, index) in options.customTopRightActions"
                :key="index"
                class="btn btn-simple btn-xs"
                :class="action.class"
                :id="action.name"
                :data-title="action.title || action.label"
                :tooltip="action.title || action.label"
                :data-tooltip="action.title || action.label"
                @click="
                  customAction({
                    action,
                    location: 'topright',
                    id: action.name,
                  })
                "
              >
                <i v-if="action.icon" :class="action.icon" />
                <span v-html="action.label ? $t(action.label) : ''"></span>
              </button>
            </template>
            <button
              class="btn btn-primary text-white btn-xs"
              v-if="innerOptions.actions && innerOptions.actions.create"
              @click="createFunction()"
            >
              <i class="fa fa-plus"></i>
              {{ $t("common.labels.createNew") }} {{ title }}
            </button>
            <div style="display: inline-block"></div>
          </div>
          <!-- START OF create MODAL -->
          <div class="modal" tabindex="-1" role="dialog" id="formModal">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content" v-if="viewMode === 'create'">
                <form @submit.prevent="createItem()">
                  <div class="modal-header bg-primary text-white">
                    <h3 class="modal-title mt-0">
                      {{ $t("common.buttons.add") }} {{ title }}
                    </h3>
                    <button
                      type="button"
                      class="close"
                      @click="closeModal()"
                      aria-label="Close"
                    >
                      <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <slot name="create-form">
                      <template v-if="formSchema && formSchema.fields">
                        <vue-form-generator
                          :schema.sync="formSchema"
                          :model="currentItem"
                          :options="formOptions"
                        ></vue-form-generator>
                      </template>
                    </slot>
                  </div>
                  <div class="modal-footer">
                    <slot name="add-modal-footer">
                      <button
                        type="button"
                        class="btn btn-default btn-simple mr-auto btn-xs"
                        @click="closeModal()"
                      >
                        {{ $t("common.buttons.cancel") }}
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary ml-auto text-white btn-xs"
                      >
                        {{ $t("common.buttons.save") }}
                      </button>
                    </slot>
                  </div>
                </form>
              </div>
              <!-- // .modal-content -->
              <div
                class="modal-content"
                v-if="viewMode === 'edit' || viewMode === 'view'"
              >
                <form @submit.prevent="editItem()">
                  <div class="modal-header bg-primary text-white">
                    <h3 class="modal-title mt-0">
                      {{ $t("common.buttons." + viewMode) }} {{ title }}
                      {{ currentItem ? currentItem._id : "" }}
                    </h3>
                    <button
                      type="button"
                      class="close"
                      aria-label="Close"
                      @click="closeModal()"
                    >
                      <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <slot name="create-form">
                      <template v-if="formSchema && formSchema.fields">
                        <vue-form-generator
                          :key="currentItem && currentItem._id"
                          :schema.sync="formSchema"
                          :model="currentItem"
                          :options="formOptions"
                        ></vue-form-generator>
                      </template>
                    </slot>
                  </div>
                  <div class="modal-footer">
                    <slot name="edit-modal-footer">
                      <button
                        type="button"
                        class="btn btn-default btn-simple mr-auto btn-xs"
                        @click="closeModal()"
                      >
                        {{ $t("common.buttons.cancel") }}
                      </button>
                      <template
                        v-if="
                          innerOptions &&
                          innerOptions.customActions &&
                          !innerOptions.noActions
                        "
                      >
                        <button
                          v-for="(action, index) in innerOptions.customActions"
                          :key="action.id || index"
                          @click="customAction({ action, item: currentItem })"
                          class="btn btn-xs btn-simple mr-1 ml-1"
                          :class="action.class"
                          type="button"
                          :data-title="action.title || action.label"
                        >
                          {{ action.label ? $t(action.label) : "" }}
                          <i :class="action.icon" v-if="action.icon"></i>
                        </button>
                      </template>
                      <button
                        type="submit"
                        v-if="viewMode === 'edit'"
                        class="btn btn-primary ml-auto text-white btn-xs"
                      >
                        {{ $t("common.buttons.save") }}
                      </button>
                      <button
                        type="button"
                        v-if="viewMode === 'view'"
                        class="btn btn-primary ml-auto btn-xs"
                        @click="closeModal()"
                      >
                        {{ $t("common.buttons.close") }}
                      </button>
                    </slot>
                  </div>
                </form>
              </div>
              <!-- // .modal-content -->
            </div>
          </div>
          <!-- END OF create MODAL -->
          <AjaxTable
            :columns="innerOptions.columns"
            :entity="name"
            :mode="innerOptions.mode"
            :url="innerOptions.url"
            :exportUrl="innerOptions.exportUrl"
            @edit="gotToEditPage"
            @view="gotToViewPage"
            @create="createFunction"
            @delete="deleteFunction"
            @customAction="customAction"
            :tableNeedsRefresh.sync="tableNeedsRefresh"
            :options="{
              pagination: innerOptions.pagination,
              noHeaders: innerOptions.noHeaders,
              filterInitiallyOn: innerOptions.filterInitiallyOn,
              saveSearchDatas: innerOptions.saveSearchDatas,
              noActions: innerOptions.noActions,
              actions: innerOptions.actions,
              customActions: innerOptions.customActions,
            }"
          >
            <template slot="table-top-more-actions"> </template>
            <!-- END OF ARRAY -->
          </AjaxTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import swal from "sweetalert2/dist/sweetalert2.js";
import VueFormGenerator from "vue-form-generator";

import apiErrors from "@/mixins/api-errors";
import EventBus from "@/stores/event-bus";

export default {
  props: {
    name: String,
    model: {
      type: Object,
    },
    schema: {
      type: Object,
    },
    options: {
      default: () => ({
        mode: "local",
        actions: {
          create: true,
          edit: true,
          view: true,
          delete: true,
          import: false,
          export: false,
        },
        columns: [],
      }),
    },
  },
  components: {
    "vue-form-generator": VueFormGenerator.component,
  },
  mixins: [apiErrors],
  created() {
    this.loadModel();
  },
  mounted() {
    this.$modal = $("#formModal");
    this.loadModel();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //    vm.loadModel();
    });
  },
  data() {
    return {
      mySelect: 3,
      opts: [
        { _id: 1, label: "eerr" },
        { _id: 2, label: "Number 2" },
        { _id: 3, label: "Number 3" },
      ],

      mySelect2: [1, 3, 5],
      $modal: null,
      currentItem: {},
      selectedItem: {},
      viewMode: false,
      tableNeedsRefresh: false,
      statsNeedsRefresh: false,
      innerOptions: {},
      innerSchema: {},
      innerModel: {},
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
      },
    };
  },
  watch: {
    // call again the method if the route changes
    name: "loadModel",
    model: "loadModel",
    options: "mergeOptions",
  },
  computed: {
    title() {
      return this.name ? this.$t(`app.labels.${this.name}`) : "";
    },
    titlePlural() {
      if (this.innerModel && this.innerModel.pluralName) {
        return this.$te(this.innerModel.pluralName)
          ? this.$t(this.innerModel.pluralName)
          : _.startCase(this.innerModel.pluralName);
      }
      return this.name ? this.$t(`app.labels.${this.name}s`) : "";
    },
    formSchema() {
      if (!this.innerSchema) {
        return [];
      }
      const formSchema = this.parseSchema(this.innerSchema);
      return { fields: formSchema };
    },
  },
  methods: {
    mergeOptions() {
      this.innerOptions = _.merge(this.innerOptions, this.options);
    },
    callbackFunctionForBAse64(e) {},
    importResponse(e) {
      // swal({title: this.$t('common.messages.successfullyImported',{title: this.name}), type: 'success'})
      this.$notifications.clear();
      if (
        (!e.improperData || e.improperData.length === 0) &&
        (!e.properDataCount || e.properDataCount.length === 0)
      ) {
        swal({
          title: this.$t("common.messages.no_data_imported", {
            title: this.name,
          }),
          type: "warning",
        });
        return;
      }

      if (e.properDataCount > 0) {
        this.$notify({
          title: this.$t("common.messages.successfullyImported", {
            title: this.name,
          }),
          type: "success",
        });
      }

      if (e.improperData.length > 0) {
        let message = "";
        e.improperData.forEach((element) => {
          message += ` - ${Object.values(element).join(" | ")}, `;
        });
        message = message.substring(0, message.length - 2);
        setTimeout(() => {
          this.$notify({
            title: `${e.improperData.length} ${this.$t(
              "common.messages.not_imported",
              { title: this.name }
            )}`,
            message,
            type: "warning",
            timeout: 30000,
          });
        }, 0);
      }
      this.tableNeedsRefresh = true;
      this.statsNeedsRefresh = true;
      this.$forceUpdate();
    },

    loadModel() {
      if (!this.options) {
        this.options = {};
      }
      this.mergeOptions();
      if (!this.model) {
        this.innerModel = this.$store.state.data.models.find(
          (model) => model.name === this.name
        );
      } else {
        this.innerModel = this.model;
      }

      if (!this.innerModel) {
        console.warn("CRUD COMPONENT ERROR", `model ${this.name} not found`);
        return;
      }
      this.innerSchema = this.schema || this.innerModel.schema;
      this.innerOptions.columns = this.formatColumns(
        this.innerSchema.properties
      );
      this.innerOptions.url =
        this.innerOptions.url ||
        this.options.url ||
        this.innerModel.url ||
        this.url ||
        `/crud/${this.name}`;

      if (this.name === "scan_verification_request") {
        this.innerOptions.customActions = [
          {
            label: "Accepter",
            icon: "fa fa-check",
            action: "acceptPoints",
            class: "bg-success text-white",
          },
          {
            label: "Refuser",
            icon: "fa fa-times",
            action: "refusePoints",
            class: "bg-danger text-white",
          },
        ];
      }

      if (this.$route.params && this.$route.params.id) {
        this.$http
          .get(`${this.innerOptions.url}/${this.$route.params.id}`)
          .then((res) => {
            if (this.$route.name === "Edit") {
              this.editFunction(res.data.body);
            } else if (this.$route.name === "View") {
              this.viewFunction(res.data.body);
            }
            this.$forceUpdate();
          })
          .catch(this.apiErrorCallback);
      }
    },

    parseSchema(schema, prefix = "") {
      if (!schema.properties) {
        return [];
      }
      if (prefix && schema.$schema) {
        console.warn("possible recursive parseSchema call", schema);
        return;
      }
      let formSchema = [];
      const size = Object.keys(schema.properties).length;
      Object.keys(schema.properties).forEach((key) => {
        const prop = schema.properties[key];
        if (
          !["_id", "metadata"].includes(key) ||
          (key === "_id" && prop.formHidden === false)
        ) {
          if (!prop) {
            console.warn("Missing prop", key);
            return;
          }
          if (prop.hidden || prop.formHidden) {
            return;
          }
          if (prop.type === "object") {
            formSchema = formSchema.concat(this.parseSchema(prop, `${key}.`));
          } else {
            if (prop.selectOptions) {
              if (!prop.selectOptions.url) {
                prop.selectOptions.url = prop.relation;
              }
              if (!prop.selectOptions.trackBy) {
                prop.selectOptions.trackBy = prop.foreignKey;
              }
              if (prop.selectOptions.label === undefined) {
                prop.selectOptions.label = prop.label || "label";
              }
              prop.selectOptions.searchable = true;
            }

            formSchema.push({
              type: prop.formType || this.getFormtype(prop),
              inputType: prop.formInputType || this.getFormInputType(prop),
              label: prop.title || prop.description || _.startCase(key),
              selectOptions: prop.selectOptions || {
                url: prop.relation,
                trackBy: prop.foreignKey,
              },
              values: prop.enum || (prop.items && prop.items.enum),
              required: prop.required,
              hint: prop.description,
              model: prefix + key,
              default: prop.default,
              multi: prop.type === "array",
              readonly: this.viewMode === "view" || prop.readonly,
              disabled: this.viewMode === "view" || prop.readonly,
              styleClasses:
                prop.formStyleClasses || (size < 8 ? "col-md-12" : "col-md-6"),
              relation: prop.relation,
              foreignKey: prop.foreignKey,
              trackBy: prop.foreignKey,
            });
          }
        }
      });
      return formSchema;
    },

    getFormtype(property) {
      let type = property.type;
      if (Array.isArray(type)) {
        const possibleTypes = ["string", "number", "boolean"];
        for (let i = 0; i < possibleTypes.length; i++) {
          if (property.type.indexOf(possibleTypes[i]) > -1) {
            type = possibleTypes[i];
          }
        }
      }
      switch (type) {
        case "number":
          return "input";
        case "boolean":
          return "checkbox";
        case "string":
        default:
          return "input";
      }
    },

    getFormInputType(property) {
      let type = property.type;
      if (Array.isArray(type)) {
        const possibleTypes = ["string", "number", "boolean"];
        for (let i = 0; i < possibleTypes.length; i++) {
          if (property.type.indexOf(possibleTypes[i]) > -1) {
            type = possibleTypes[i];
          }
        }
      }

      switch (type) {
        case "string":
          switch (property.format) {
            case "email":
              return "email";
            case "date-time":
              return "date";
            default:
              return "text";
          }
        case "number":
          return "number";
        case "boolean":
        case "array":
        case "object":
          return "string";
        default:
          console.error("type not known ", type, property);
          return type;
      }
    },

    getColumnType(property) {
      if (property.columnType) {
        return property.columnType;
      }
      if (property.column && property.column.type) {
        return property.column.type;
      }
      let type = property.type;
      if (Array.isArray(type)) {
        const possibleTypes = ["string", "number", "boolean"];
        for (let i = 0; i < possibleTypes.length; i++) {
          if (property.type.indexOf(possibleTypes[i]) > -1) {
            type = possibleTypes[i];
          }
        }
      }

      switch (type) {
        case "string":
          switch (property.format) {
            case "date-time":
              return "text";
            default:
              return "text";
          }
        case "number":
          return "number";
        case "boolean":
          return "boolean";
        case "array":
        case "object":
          return "object";
        default:
          return "text";
      }
    },

    openModal() {
      this.$modal.modal("show");
    },

    closeModal() {
      window.history.replaceState({}, null, `/app/${this.name}`);
      this.$modal.modal("hide");
    },

    gotToEditPage(item) {
      // this.$router.push({path: `/app/${this.name}/${item._id}/edit`})
      window.history.replaceState(
        {},
        null,
        `/app/${this.name}/${item._id}/edit`
      );
      this.editFunction(item);
    },

    gotToViewPage(item) {
      // this.$router.push(`/app/${this.name}/${item._id}`)
      window.history.replaceState({}, null, `/app/${this.name}/${item._id}`);
      this.viewFunction(item);
    },

    createItem() {
      if (this.innerOptions.url);
      this.$http
        .post(this.innerOptions.url, this.currentItem)
        .then((res) => {
          EventBus.$emit(`${this.name}:created`, res.data);
          swal({
            title: this.$t("common.messages.successfullyCreated", {
              title: this.type,
            }),
            type: "success",
          });
          this.tableNeedsRefresh = true;
          this.statsNeedsRefresh = true;
          this.$forceUpdate();
          this.closeModal();
        })
        .catch(this.apiErrorCallback);
      return false;
    },

    editItem() {
      if (this.innerOptions.url);
      this.$http
        .put(
          `${this.innerOptions.url}/${this.currentItem._id}`,
          this.currentItem
        )
        .then((res) => {
          EventBus.$emit(`${this.name}:created`, res.data);
          swal({
            title: this.$t("common.messages.successfullyModified", {
              title: this.type,
            }),
            type: "success",
          });
          this.tableNeedsRefresh = true;
          this.$forceUpdate();

          this.closeModal();
        })
        .catch(this.apiErrorCallback);
      return false;
    },

    editFunction(item) {
      this.viewMode = "edit";
      this.currentItem = item;
      this.$http
        .get(`${this.innerOptions.url}/${item._id}`)
        .then((res) => {
          this.currentItem = res.data.body;
          this.openModal();
        })
        .catch(this.apiErrorCallback);
    },

    viewFunction(item) {
      this.viewMode = "view";
      this.currentItem = item;
      this.openModal();
    },

    deleteFunction(item) {
      swal({
        title: this.$t("common.messages.are_you_sure"),
        text: this.$t("common.messages.wont_be_able_recover"),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("common.buttons.yes_delete_it"),
        cancelButtonText: this.$t("common.buttons.cancel"),
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`${this.innerOptions.url}/${item._id}`)
            .then((res) => {
              this.tableNeedsRefresh = true;
              this.statsNeedsRefresh = true;
              this.$forceUpdate();
            })
            .catch((err) => console.error(err));
        }
      });
    },

    createFunction() {
      this.viewMode = "create";
      this.currentItem = {};
      this.openModal();
    },

    formatColumns(properties) {
      let newcolumns = [];
      Object.keys(properties).forEach((key) => {
        const newCol = {};
        const prop = properties[key];
        if (!prop.hidden && !prop.listHidden) {
          newCol.field = key;
          newCol.relation = prop.relation;
          newCol.type = this.getColumnType(prop);
          newCol.label = _.startCase(key);
          newCol.filterOptions = prop.columnFilterOptions || { enabled: false };
          newCol.sortable = prop.columnSortable || true;
          newcolumns.push(newCol);
        }
      });

      if (newcolumns.length > 8) {
        newcolumns = newcolumns.slice(0, 8);
      }

      if (!newcolumns.find((col) => col.field === "ACTIONS")) {
        newcolumns.push({
          field: "ACTIONS",
          label: "Actions",
          filterable: false,
        });
      }
      return newcolumns;
    },

    customAction(body) {
      const { action } = body;
      console.log("customAction", body);
      if (action && typeof action.action === "string") {
        if (this[action.action]) {
          this[action.action].bind(this);
          return this[action.action](body, this);
        }
        return;
      }
      return action && action.action && action.action(body, this);
    },

    acceptPoints(body, vm) {
      window.console.log(body);
      vm.$http
        .put(`${this.innerOptions.url}/${body.item._id}/accept`)
        .then((res) => {
          vm.tableNeedsRefresh = true;
          vm.statsNeedsRefresh = true;
          this.$notify({
            title: "Scan acccepté ajouté au compte de l'utilisateur",
            type: "success",
          });
        })
        .catch((err) => {
          this.$notify({
            title:
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : err.message,
            type: "danger",
          });
        });
    },

    refusePoints(body, vm) {
      window.console.log(body);
      vm.$http
        .put(`${this.innerOptions.url}/${body.item._id}`, {
          ...body.item,
          status: "rejected",
        })
        .then((res) => {
          vm.tableNeedsRefresh = true;
          vm.statsNeedsRefresh = true;
          this.$notify({
            title: "Scan refusé",
            type: "success",
          });
        })
        .catch((err) => {
          this.$notify({
            title:
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : err.message,
            type: "danger",
          });
        });
    },
  },
};
</script>
<style>
.field-EnyoSelect div {
  width: 100%;
}

.multiselect__content-wrapper {
  max-width: 100% !important;
}
</style>
